import { Button, IconButton, styled } from '@mui/material';

export const ActionButton: any  = styled(Button)({
    width: '100%',
    borderRadius: '9999px',
    fontWeight: '700',
    fontFamily: 'inherit',
    textTransform: 'none',
    fontSize: '1.15rem',
    lineHeight: '1.65rem',
    borderColor: '',
    color: 'white'
});

export const ActionButtonSmall: any  = styled(Button)({
    width: '100%',
    borderRadius: '9999px',
    fontWeight: '600',
    fontFamily: 'inherit',
    textTransform: 'none',
    fontSize: '0.8rem',
    borderColor: 'white',
    color: 'white'
});

export const ActionIconButtonPlus: any  = styled(IconButton)({
    border: '1px solid white',
    backgroundColor: '#f6a320',
    color: 'white',
    '&:hover': {
        backgroundColor: '#f9bf63',
        boxShadow: 'none',
    }
});

export const ActionIconButtonGrey: any  = styled(IconButton)({
    borderColor: 'white',
    backgroundColor: 'rgb(243 244 246 / 1)',
    color: 'black',
});